import React, { Fragment, useState, useContext } from "react";
import classnames from "classnames";
import { InputContainer, Input, Text, MobileContext } from "components/common";
import { colors } from "theme";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { REFETCH_CARD_STATUS } from "utils/mutations";
import { track } from "../../../../../../../utils/analytics";

function Terminate({ user, roles, SettingsButton }) {
  const { isMobile } = useContext(MobileContext);

  const [cardStatus, setCardStatus] = useState(
    user.card && user.card.status ? user.card.status.toLowerCase() : null
  );
  const [terminateInput, setTerminateInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [inProgress, setInProgress] = useState(false);
  // const [isUpdated, setIsUpdated] = useState(false);
  const [updateCardStatus] = useMutation(UPDATE_CARDSTATUS_TERMINATE);

  const handleTerminateInputChange = newValue => {
    setTerminateInput(newValue);
    setErrorMessage("");
  };

  const optionDisabled = [null, "pending", "locked", "terminated"].includes(
    cardStatus
  );

  return (
    <Fragment>
      <div
        className={classnames(
          "flex-1 py-4",
          {
            "text-gray-400": optionDisabled
          },
          {
            [`py-4 px-10 ${!(roles || {}).admin ? "" : "border-l"}`]: !isMobile
          },
          {
            "text-center": isMobile
          }
        )}
      >
        <Text className="font-bold text-md">Lost or stolen card</Text>
        <Text className="text-sm">
          Please type "TERMINATE" and submit your request. Your card will be
          immediately permanently disabled and a new card will be sent to you
          within 3-5 business days.
        </Text>
      </div>
      <div className="flex-1 py-4">
        <div className="">
          <InputContainer className="mb-3" style={{ maxWidth: "400px" }}>
            <Input
              placeholder='Type "TERMINATE" here'
              disabled={optionDisabled}
              onChange={e => {
                if (!(user.card ? user.card.status : null)) {
                  // If we never had a valid status to begin with (something was wrong
                  // with our card), don't handle anything
                  return false;
                }
                handleTerminateInputChange(e.target.value);
              }}
            />
          </InputContainer>
          <div className="mb-3 text-red-600">{errorMessage}</div>
          <SettingsButton
            className={inProgress || optionDisabled ? "disabled" : ""}
            disabled={
              inProgress || optionDisabled || terminateInput !== "TERMINATE"
            }
            onClick={e => {
              track("DASHBOARD_SETTINGS_MANAGE_CARD_TERMINATION_SUBMITTED");
              if (!cardStatus) {
                // setErrorMessage("Can't terminate card right now");
                track("DASHBOARD_SETTINGS_MANAGE_CARD_TERMINATION_FAILURE", {
                  message: "could not terminate card"
                });
                return false;
              }
              if (terminateInput === "TERMINATE") {
                console.log("terminated");
                setInProgress(true);
                // setErrorMessage('');

                return updateCardStatus({
                  variables: {
                    user_id: user.email,
                    status: "terminated"
                  },
                  onCompleted: data => {},
                  refetchQueries: () => [{ query: REFETCH_CARD_STATUS }],
                  awaitRefetchQueries: true
                })
                  .then(res => {
                    console.log(res);
                    const { data: { updateCardStatus = {} } = {} } = res || {};
                    if (updateCardStatus.status === "ERROR") {
                      setInProgress(false);
                      setErrorMessage("Error terminating card");
                      return { success: false };
                    }
                    console.log("COMPLETED");
                    setInProgress(false);
                    // setIsUpdated(true);
                    track("DASHBOARD_SETTINGS_MANAGE_CARD_TERMINATION_SUCCESS");
                    return { success: true };
                  })
                  .catch(e => {
                    console.log(e.message);
                    setInProgress(false);
                    // setErrorMessage('Cannot complete');
                    track(
                      "DASHBOARD_SETTINGS_MANAGE_CARD_TERMINATION_FAILURE",
                      {
                        message: "could not terminate card"
                      }
                    );
                    return { success: false };
                  });
              }
              setErrorMessage("Please enter TERMINATE in capital letters");

              // setErrorMessage('You did not enter TERMINATE correctly');
            }}
          >
            Submit
          </SettingsButton>
        </div>
      </div>
    </Fragment>
  );
}

const UPDATE_CARDSTATUS_TERMINATE = gql`
  mutation UpdateCardStatusTerminate($status: String!) {
    updateCardStatus(status: $status) {
      status
    }
  }
`;

export default Terminate;
